import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Tooltip from "../Common/Tooltip";
import { useForm } from "react-hook-form";
import { posServices } from "../../Services/pos.service";
import { positiveNumbersOnly } from "../../Config/Regex";
import ResultModal from "../Common/ResultModal";

const ChangeBillNumber = ({ show, handleHide, posId }) => {
  const [serverError, setServerError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, control, formState, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const confirmChange = data => {
    posServices
      .changeDocumentNumber(posId, Number(data.documentNumber))
      .then(res => {
        if (res.status === 200) {
          handleHide();
          setShowSuccessModal(true);
        } else {
          setServerError(res.data.errors[0].value);
        }
      })
      .catch(err => {
        setServerError(err);
      });
  };

  return (
    <>
      <ResultModal
        title={translator("PosDetail-ChangeBillNumber-SuccessTitle")}
        text={translator("PosDetail-ChangeBillNumber-Success")}
        show={showSuccessModal}
        btnClass="btn btn-primary"
        handleClose={() => {
          setShowSuccessModal(false);
        }}
      />
      <Modal show={show} onHide={handleHide} centered>
        <Modal.Header>
          <Modal.Title>{translator("PosDetail-ChangeBillNumber")}</Modal.Title>
        </Modal.Header>
        {posId && (
          <Modal.Body>
            <div className="form-group">
              <label>{translator("POS-New_EditPOS-DocumentNumber")}</label>
              <Tooltip text={translator("POS-DocumentNumber-Msg")} />
              <input
                name="documentNumber"
                className="form-control"
                ref={register({
                  required: true,
                  pattern: positiveNumbersOnly,
                })}
              />
              {errors.documentNumber &&
                errors.documentNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PositiveNumbersOnly")}
                  </p>
                )}
              {errors.documentNumber &&
                errors.documentNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}

              {serverError && (
                <p className="text-danger">{translator(serverError)}</p>
              )}
            </div>
          </Modal.Body>
        )}
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}>
            {translator("General-Close")}
          </button>
          <button
            onClick={handleSubmit(confirmChange)}
            type="button"
            className="btn btn-primary">
            {translator("Btn-Change")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangeBillNumber;
